import { type ReactNode, useRef } from 'react';

interface LoginSuggestionsListProps {
  id: string;
  open: boolean;
  suggestions: string[];
  currentValue: string | undefined;
  onSelect: (value: string) => void;
  children: ReactNode;
}

export function LoginSuggestionsList({
  id,
  open,
  suggestions,
  currentValue,
  onSelect,
  children,
}: LoginSuggestionsListProps) {
  const touchStartY = useRef(0);

  return (
    <div className="relative">
      {children}
      {open && (
        <ul
          id={id}
          role="listbox"
          className="absolute top-full -mt-5 left-0 w-full z-20 bg-neutral-m5 rounded-8 overflow-y-auto max-h-60 list-none p-0 m-0 shadow-medium border border-neutral-m1"
        >
          {suggestions.map((suggestion) => (
            <li
              key={suggestion}
              role="option"
              aria-selected={suggestion === currentValue}
              className="px-4 py-3.5 text-base text-neutral-p3 cursor-pointer bg-neutral-m5 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-neutral-m2"
              onMouseDown={() => onSelect(suggestion)}
              onTouchStart={(e) => {
                touchStartY.current = e.touches[0].clientY;
              }}
              onTouchEnd={(e) => {
                if (Math.abs(e.changedTouches[0].clientY - touchStartY.current) < 10) {
                  e.preventDefault();
                  onSelect(suggestion);
                }
              }}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
